import { _ as _sfc_main } from "./VaRating.vue_vue_type_script_lang-240b6cb3.mjs";
import { resolveComponent, openBlock, createElementBlock, normalizeClass, createElementVNode, withKeys, Fragment, renderList, createBlock, mergeProps, withCtx, renderSlot, normalizeProps, guardReactiveProps, createCommentVNode, normalizeStyle, toDisplayString } from "vue";
import { _ as _export_sfc } from "../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaRating_vue_vue_type_style_index_0_lang = "";
const _hoisted_1 = ["aria-label"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_VaRatingItemNumberButton = resolveComponent("VaRatingItemNumberButton");
  const _component_va_rating_item = resolveComponent("va-rating-item");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["va-rating", _ctx.rootClass]),
    "aria-label": _ctx.tp(_ctx.$props.ariaLabel, { max: _ctx.$props.max, value: _ctx.$props.modelValue })
  }, [
    createElementVNode("div", {
      class: "va-rating__item-wrapper",
      onKeyup: [
        _cache[0] || (_cache[0] = withKeys(($event) => _ctx.onArrowKeyPress(-1), ["left"])),
        _cache[1] || (_cache[1] = withKeys(($event) => _ctx.onArrowKeyPress(1), ["right"]))
      ],
      onMouseenter: _cache[2] || (_cache[2] = (...args) => _ctx.onMouseEnter && _ctx.onMouseEnter(...args)),
      onMouseleave: _cache[3] || (_cache[3] = (...args) => _ctx.onMouseLeave && _ctx.onMouseLeave(...args))
    }, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.$props.max, (itemNumber) => {
        return openBlock(), createBlock(_component_va_rating_item, mergeProps({
          key: itemNumber,
          class: "va-rating__item"
        }, _ctx.VaRatingItemProps, {
          "aria-label": _ctx.tp(_ctx.$props.ariaItemLabel, { max: _ctx.$props.max, value: itemNumber }),
          "model-value": _ctx.getItemValue(itemNumber - 1),
          tabindex: _ctx.tabIndexComputed,
          disabled: _ctx.$props.disabled,
          readonly: _ctx.$props.readonly,
          onHover: ($event) => _ctx.isInteractionsEnabled && _ctx.onItemHoveredValueUpdate(itemNumber - 1, $event),
          "onUpdate:modelValue": ($event) => _ctx.isInteractionsEnabled && _ctx.onItemValueUpdate(itemNumber - 1, $event)
        }), {
          default: withCtx(({ value, onClick }) => [
            renderSlot(_ctx.$slots, "item", normalizeProps(guardReactiveProps({ value, onClick, index: itemNumber })), () => [
              _ctx.$props.numbers ? (openBlock(), createBlock(_component_VaRatingItemNumberButton, mergeProps({ key: 0 }, _ctx.VaRatingItemNumberButtonProps, {
                "model-value": value,
                "item-number": itemNumber
              }), null, 16, ["model-value", "item-number"])) : createCommentVNode("", true)
            ])
          ]),
          _: 2
        }, 1040, ["aria-label", "model-value", "tabindex", "disabled", "readonly", "onHover", "onUpdate:modelValue"]);
      }), 128))
    ], 32),
    _ctx.$props.texts && _ctx.$props.texts.length === _ctx.$props.max ? (openBlock(), createElementBlock("span", {
      key: 0,
      class: "va-rating__text-wrapper",
      style: normalizeStyle({ color: _ctx.computedColor })
    }, toDisplayString(_ctx.$props.texts[Math.round(_ctx.visibleValue) - 1]), 5)) : createCommentVNode("", true)
  ], 10, _hoisted_1);
}
const _VaRating = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  _VaRating as _
};
//# sourceMappingURL=VaRating-243f3358.mjs.map
